<p>Owner: <b>{{ membership.owner_first_name }} {{ membership.owner_last_name }}</b></p>

<p>Currently assigned member: <b>{{ membership.all_customers[0].first_name }} {{ membership.all_customers[0].last_name }}</b></p>

<div class="form-group">
  <label>New member</label>
  <select id="memberSelectLoading" class="custom-select" name="selectedCustomerId"
          *ngIf="loadingRelations" disabled>
    <option>Loading...</option>
  </select>
  <select id="memberSelect" class="custom-select" name="selectedCustomerId"
          *ngIf="!loadingRelations"
          [(ngModel)]="selectedCustomerId">
    <option [ngValue]="null">--------</option>
    <option [ngValue]="membership.owner_id">
      {{ membership.owner_first_name }} {{ membership.owner_last_name }}
    </option>
    <option *ngFor="let relation of relationsList.results"
            [ngValue]="relation.related_customer_id">
      {{ relation.related_customer_first_name }} {{ relation.related_customer_last_name }}
    </option>
  </select>
</div>

<p class="text-muted">
  The membership will be reassigned to the new member, and will only be usable by the new member. The owner will not be changed.
</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
